import getCache from '@/utils/getCache'
import request from '@/utils/request';
import setCache from '@/utils/setCache';
import store from '@/vuex/store.js';

class Auth {
  loggedIn() {
    const currentUser = getCache({
      key: 'currentUser'
    });
    if (currentUser) {
      return true
    } else {
      return false
    }
  }

  getAuthorizedViewList(isRefreshState, isForceUpdateCache) {
    // setCache({
    //   key: 'staffId',
    //   type: 'localStorage',
    //   value: 123456,
    //   time: 24 * 60 * 60 * 1000
    // });
    // let staffId = getCache({
    //   key: 'staffId',
    //   type: 'localStorage'
    // });
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (!userInfo) {
      return null;
    }
    let staffId = userInfo.id;
    // let cacheKey = 'staff-' + staffId + '-auth-view';
    // 有缓存获取缓存，没缓存发送请求
    let authorizedViewList = null;
    if (authorizedViewList === null || isForceUpdateCache) {
      request(`/v1/omsAuthResource/authorizedView`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Staff': staffId
        }
      }).then(res => {
        authorizedViewList = res.obj;
        store.commit('updateRoutes', authorizedViewList);
        store.commit('setAuthViews', authorizedViewList);
        // setCache({
        //   key: cacheKey,
        //   type: 'sessionStorage',
        //   value: res.obj,
        //   time: 24 * 60 * 60 * 1000
        // });
      });
    } else {
      store.commit('updateRoutes', authorizedViewList);
      store.commit('setAuthViews', authorizedViewList);
    }
    return authorizedViewList;
  }

  checkViewAuthority(authId) {
    if (!store.state.authEnable) {
      return true;
    }
    return store.state.authViews[authId];
    // let authorizedViewList = this.getAuthorizedViewList(false, false, true);
    // if (authorizedViewList) {
    //   return authorizedViewList.includes(authId);
    // } else {
    //   return false;
    // }
  }
}

export default new Auth()



// WEBPACK FOOTER //
// ./src/utils/auth.js